function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 83.431,
  cy: 74.46,
  r: 48.041,
  stroke: "#C9D5EB",
  strokeWidth: 3,
  strokeDasharray: "1 5"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#lock_svg__filter0_dd_5122_3119)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 83.431,
  cy: 74.459,
  r: 43.216,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M92 74H76v10h16V74zM80 74v-6a4.012 4.012 0 014-4v0a4.012 4.012 0 014 4v6",
  stroke: "#1AC3DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M102 78a17.998 17.998 0 01-18 18 18 18 0 01-18-18V58l18-4 18 4v20z",
  stroke: "#1AC3DA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "lock_svg__filter0_dd_5122_3119",
  x: 0.215,
  y: 0.243,
  width: 166.434,
  height: 192.432,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.164931 0 0 0 0 0.218629 0 0 0 0 0.395833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5122_3119"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 17.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.184314 0 0 0 0 0.223529 0 0 0 0 0.352941 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_5122_3119",
  result: "effect2_dropShadow_5122_3119"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_5122_3119",
  result: "shape"
})));

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 147,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgLock;